var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderDroparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.073 8.74852C11.073 8.90019 11.0146 9.04604 10.9038 9.1627C10.6763 9.3902 10.3088 9.3902 10.0813 9.1627L6.99547 6.07685L3.90963 9.1627C3.68213 9.3902 3.31463 9.3902 3.08713 9.1627C2.85963 8.9352 2.85963 8.56768 3.08713 8.34018L6.58713 4.84018C6.81463 4.61268 7.18213 4.61268 7.40963 4.84018L10.9096 8.34018C11.0263 8.45685 11.0788 8.6027 11.0788 8.75436L11.073 8.74852Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderDroparrow);
export default __webpack_public_path__ + "static/media/header_droparrow.6b60869492a2c4c1994b84d7cc035c86.svg";
export { ForwardRef as ReactComponent };